import * as Yup from "yup";

const PromotionUserRegistrationSchema = Yup.object().shape({
  image: Yup.lazy((value) => {
    if (typeof value === "string") {

      return Yup.mixed().notRequired();
    }
    return Yup.mixed().required("Image is required");
  }),

  promotionName: Yup.string().required("Promotion name is required"),

  rewardAmount: Yup.number()
  .typeError("Reward amount must be a valid number")
  .required("Reward amount is required")
  .min(1, "Reward amount must be at least 1"),

  couponCode: Yup.string().required("Coupon code is required"),

  startDateTime: Yup.date()
    .required("Start date and time is required")
    .typeError("Start date and time is invalid"),

  endDateTime: Yup.date()
    .required("End date and time is required")
    .typeError("End date and time is invalid")
    .min(Yup.ref("startDateTime"), "End date must be after start date"),

  status: Yup.boolean().required("Status is required"),

  comments: Yup.string().required("Comments are required"),
});
export default PromotionUserRegistrationSchema;